import { useConnector } from 'react-instantsearch-hooks-web';
import connectStats, {
	StatsConnectorParams,
	StatsWidgetDescription,
} from 'instantsearch.js/es/connectors/stats/connectStats';

export type UseStatsProps = StatsConnectorParams;

export const useAlgoliaStats = (props?: UseStatsProps) => {
	return useConnector<StatsConnectorParams, StatsWidgetDescription>(connectStats, props);
};
